import floorNumberToText from "../newcomponent/FloorConverter";

function formatDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

const structureLocation = (data, projectId, day) => {
  console.log("day received at structureLocation : ", day);
  const randomMs = Math.floor(Math.random() * 1000); // Generates a random number between 0 and 999
  const timestamp = day
    ? new Date(`${day}T12:35:23.${randomMs}Z`).getTime()
    : new Date().getTime(); // Use the provided date or current date
  console.log("structureLocation timestamp : ", timestamp);
  // let timestamp = new Date().getTime();
  let structuredArray = [];
  let blockData = Object.values(data);
  let id = 1;

  for (let index = 0; index < blockData.length; index++) {
    let item = blockData[index];

    if (item.name) {
      structuredArray.push({
        id: id,
        name: item.name,
        displayText: item.name,
        type: "block",
        path: `${projectId}/Blocks/${String(
          index + 1
        )}/BlockImages/dateStamp:${formatDate(timestamp)}`,
      });
      id = id + 1;
    }

    // Sort floorItems numerically
    let floorItems = Object.keys(item.floorNumber)
      .map((key) => parseInt(key.replace("floorNumber", ""), 10))
      .sort((a, b) => a - b);

    floorItems.map((floorNum) => {
      let pointItems = Object.entries(
        item.floorNumber[`floorNumber${floorNum}`]
      ).sort(([a], [b]) => {
        // Sort point items numerically by their keys
        return (
          parseInt(a.replace("pointNumber", "")) -
          parseInt(b.replace("pointNumber", ""))
        );
      });

      let pointArray = pointItems
        .map(([pKey, pItem], pIndex) => {
          if (pItem.name) {
            return {
              id: pIndex,
              name: pItem.name,
              displayText: `${item.name} > ${floorNumberToText(
                floorNum - 1
              )} > ${pItem.name}`,
              type: "point",
              path: `${projectId}/Blocks/${String(
                index + 1
              )}/Images/floorNumber${String(floorNum)}/dateStamp:${formatDate(
                timestamp
              )}/pointNumber${String(pIndex + 1)}`,
            };
          }
        })
        .filter(Boolean);

      structuredArray.push({
        id: id,
        name: floorNumberToText(floorNum - 1),
        displayText: `${item.name} > ${floorNumberToText(floorNum - 1)}`,
        type: "floor",
        path: `${projectId}/Blocks/${String(
          index + 1
        )}/Images/floorNumber${String(
          floorNum
        )}/FloorImages/dateStamp:${formatDate(timestamp)}`,
        pointDetails: pointArray.length > 0 ? pointArray : null,
      });
      id = id + 1;
    });
  }
  console.log("structuredArray : ", structuredArray);
  return structuredArray;
};

export default structureLocation;
